<template>
  <el-container>
    <el-main>
      <div class="home">
        <el-card class="ta-main">

          <div class="ta-header ta-header__main">
            {{$t('results.title')}}
          </div>

          <el-divider/>

          <div class="ta-header ta-header__section">
            {{$t('results.sourceDataTitle')}}
          </div>

          <div class="ta-header">
            {{$t('general.title')}}
          </div>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('general.power')}}
            </el-col>
            <el-col :span="8">
              {{input.power}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('general.frequency')}}
            </el-col>
            <el-col :span="8">
              {{input.frequency}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('general.bladeCount')}}
            </el-col>
            <el-col :span="8">
              {{input.bladeCount}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('general.directionBladeCount')}}
            </el-col>
            <el-col :span="8">
              {{input.directionBladeCount}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('general.yearsOfUse')}}
            </el-col>
            <el-col :span="8">
              {{input.yearsOfUse}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('general.maxHeight')}}
            </el-col>
            <el-col :span="8">
              {{input.maxHeight}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('general.unrelievedStress')}}
            </el-col>
            <el-col :span="8">
              {{input.unrelievedStress}}
            </el-col>
          </el-row>

          <el-row class="ta-row" v-if="data.steelParameters">
            <el-col :span="16" class="ta-label">
              {{$t('results.materialName')}}
            </el-col>
            <el-col :span="8">
              {{$t('results.materialType')}}
            </el-col>
          </el-row>

          <el-row class="ta-row" v-if="data.steelParameters">
            <el-col :span="16" class="ta-label">
              {{$t('results.materialStrength')}}
            </el-col>
            <el-col :span="8">
              {{data.steelParameters.strengthLimit}}
            </el-col>
          </el-row>

          <el-divider/>

          <div class="ta-header">
            {{$t('hours.title')}}
          </div>

          <el-row class="ta-row" v-if="input.hours">
            <el-col :span="16" class="ta-label">
              {{$t('hours.total')}}
            </el-col>
            <el-col :span="8">
              {{input.hours.total}}
            </el-col>
          </el-row>

          <el-row class="ta-row ta-row__label">
            <el-col :span="24" class="ta-label ta-label__bold">
              {{$t('hours.rangesTitle')}}
            </el-col>
          </el-row>

          <template v-if="input.hours">
            <template v-for="zone in input.hours.zones">
              <div class="ta-row-block" :key="zone.label">
                <el-col :span="12" class="ta-label">
                  {{$t('hours.' + zone.label)}}
                </el-col>
                <el-col :span="12">
                  <el-row class="ta-row" v-for="range in zone.ranges" :key="zone.label + range.label ">
                    <el-col :span="16">
                      {{$t('hours.' + range.label)}}
                    </el-col>
                    <el-col :span="8">
                      {{Math.round(range.value)}}
                    </el-col>
                  </el-row>
                </el-col>
              </div>
            </template>
          </template>
          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('hours.startStopCount')}}
            </el-col>
            <el-col :span="8">
              {{input.startStopCount}}
            </el-col>
          </el-row>

          <el-divider/>

          <div class="ta-header">
            {{$t('results.futureHoursTitle')}}
          </div>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('futureHours.yearsUntilRepair')}}
            </el-col>
            <el-col :span="8">
              {{input.yearsUntilRepair}}
            </el-col>
          </el-row>

          <el-row class="ta-row ta-row__label">
            <el-col :span="24" class="ta-label ta-label__bold">
              {{$t('hours.rangesTitle')}}
            </el-col>
          </el-row>

          <template v-if="input.hours">
            <template v-for="zone in input.hours.zones">
              <div class="ta-row-block" :key="'future_' + zone.label">
                <el-col :span="12" class="ta-label">
                  {{$t('hours.' + zone.label)}}
                </el-col>
                <el-col :span="12">
                  <el-row class="ta-row" v-for="range in zone.ranges" :key="'future_' + zone.label + range.label ">
                    <el-col :span="16">
                      {{$t('hours.' + range.label)}}
                    </el-col>
                    <el-col :span="8">
                      {{Math.round(range.futureValue)}}
                    </el-col>
                  </el-row>
                </el-col>
              </div>
            </template>
          </template>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('hours.startStopCount')}}
            </el-col>
            <el-col :span="8">
              {{input.futureStartStopCount}}
            </el-col>
          </el-row>

          <el-divider/>

          <div class="ta-header ta-header__section">
            {{$t('results.protocol.title')}}
          </div>

          <div class="ta-header">
            {{$t('results.protocol.frequency.title')}}
          </div>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.frequency.frequencyTitle')}}
            </el-col>
            <el-col :span="8">
              {{(0.22 * input.frequency).toFixed(2)}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.frequency.bladeFrequencyTitle')}}
            </el-col>
            <el-col :span="8">
              {{(input.frequency * input.bladeCount).toFixed(1)}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.frequency.directionalBladeFrequencyTitle')}}
            </el-col>
            <el-col :span="8">
              {{(input.frequency * input.directionBladeCount).toFixed(1)}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.frequency.pulsationFrequencyTitle')}}
            </el-col>
            <el-col :span="8">
              {{(0.78 * input.frequency).toFixed(2)}}
            </el-col>
          </el-row>

          <div class="ta-header">
            {{$t('results.protocol.actualData.title')}}
          </div>

          <el-row class="ta-row" v-if="input.hours">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.actualData.averageHoursLabel')}}
            </el-col>
            <el-col :span="8">
              {{input.hours.total / input.yearsOfUse}}
            </el-col>
          </el-row>

          <el-row class="ta-row" v-if="input.hours">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.actualData.averageStartStopLabel')}}
            </el-col>
            <el-col :span="8">
              {{input.startStopCount / input.yearsOfUse}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.actualData.damageLabel')}}
            </el-col>
            <el-col :span="8">
              {{getDamageValue()}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.actualData.resourceLeftLabel')}}
            </el-col>
            <el-col :span="8">
              {{getResourceLeft()}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.actualData.maxDamageLabel')}}
            </el-col>
            <el-col :span="8">
              {{getMaxDamagePercents()}}
            </el-col>
          </el-row>

          <div class="ta-header">
            {{$t('results.protocol.forecast.title')}}
          </div>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.forecast.totalHoursLabel')}}
            </el-col>
            <el-col :span="8">
              {{totalForecastHours}}
            </el-col>
          </el-row>

          <el-row class="ta-row" v-if="data.resourceLeft">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.forecast.averageHoursLabel')}}
            </el-col>
            <el-col :span="8">
              {{averageForecastHours}}
            </el-col>
          </el-row>

          <el-row class="ta-row" v-if="data.resourceLeft">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.forecast.averageStartStopLabel')}}
            </el-col>
            <el-col :span="8">
              {{averageForecastStartStop}}
            </el-col>
          </el-row>

          <el-row class="ta-row">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.forecast.damagePredictionLabel')}}
            </el-col>
            <el-col :span="8">
              {{getDamagePrediction()}}
            </el-col>
          </el-row>

          <el-row class="ta-row" v-if="data.resourceLeft">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.forecast.resourceLeftLabel')}}
            </el-col>
            <el-col :span="8">
              {{getPredictedValue(data.resourceLeft.years)}}
            </el-col>
          </el-row>

          <el-row class="ta-row" v-if="data.resourceLeft">
            <el-col :span="16" class="ta-label">
              {{$t('results.protocol.forecast.hoursLeftLabel')}}
            </el-col>
            <el-col :span="8">
              {{getPredictedValue(data.resourceLeft.hours / 1000)}}
            </el-col>
          </el-row>

          <range-hours ref="chart1" :data="input"/>
          <range-hours-relative ref="chart2" :data="data" id="rangeHoursRelative"/>
          <static-stress-lines ref="chart3" :data="data" id='staticStressLine'/>
          <dynamic-stress-lines ref="chart4" :data="data" id='dynamicStressLine'/>

<!--          <frequency-static-stress ref="chart5" :data="data" id="frequencyStaticStress"/>-->
          <frequency-dynamic-stress ref="chart6" :data="data" id="frequencyDynamicStress"/>
          <frequency-rotor-dynamic-stress ref="chart7" :data="data" id="frequencyRotorDynamicStress"/>
          <frequency-blade-dynamic-stress ref="chart8" :data="data" id="frequencyBladeDynamicStress"/>

<!--          <resource-used-ranges ref="chart9" :data="data" id="resourceUsedRanges"/>-->
          <resource-used-zones ref="chart10" :data="data" id="resourceUsedZones"/>
          <resource-used-frequencies ref="chart11" :data="data" id="resourceUsedFrequencies"/>

        </el-card>
      </div>
    </el-main>
    <el-footer class="ta-footer">
      <el-button @click="print">
        Распечатать
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import store from '../data/store'
import { EventBus } from '../EventBus'

import RangeHours from './charts/RangeHours'
import RangeHoursRelative from './charts/RangeHoursRelative'
import StaticStressLines from './charts/StaticStressLines'
import DynamicStressLines from './charts/DynamicStressLines'
// import FrequencyStaticStress from './charts/FrequencyStaticStress'
import FrequencyDynamicStress from './charts/FrequencyDynamicStress'
import FrequencyRotorDynamicStress from './charts/FrequencyRotorDynamicStress'
import FrequencyBladeDynamicStress from './charts/FrequencyBladeDynamicStress'
// import ResourceUsedRanges from './charts/ResourceUsedRanges'
import ResourceUsedZones from './charts/ResourceUsedZones'
import ResourceUsedFrequencies from './charts/ResourceUsedFrequencies'

export default {
  name: 'result',
  components: {
    RangeHours,
    RangeHoursRelative,
    StaticStressLines,
    DynamicStressLines,
    // FrequencyStaticStress,
    FrequencyDynamicStress,
    FrequencyRotorDynamicStress,
    FrequencyBladeDynamicStress,
    // ResourceUsedRanges,
    ResourceUsedZones,
    ResourceUsedFrequencies
  },
  data () {
    return {
      data: {}
    }
  },
  computed: {
    input () {
      return this.data.userInput || {}
    },
    totalForecastHours () {
      if (!this.input.hours) {
        return 0
      }
      let totalHours = 0
      for (let zone of this.input.hours.zones) {
        for (let range of zone.ranges) {
          totalHours += range.futureValue
        }
      }
      return totalHours
    },
    averageForecastHours () {
      if (this.totalForecastHours === 0 || !this.input || !this.input.yearsUntilRepair) {
        return 0
      }
      return Math.round(this.totalForecastHours / this.input.yearsUntilRepair)
    },
    averageForecastStartStop () {
      if (!this.input || !this.input.futureStartStopCount || !this.input.yearsUntilRepair) {
        return 0
      }
      return Math.round(this.input.futureStartStopCount / this.input.yearsUntilRepair)
    }
  },
  methods: {
    rerender () {
      for (const ref in this.$refs) {
        if (Object.prototype.hasOwnProperty.call(this.$refs, ref)) {
          const chart = this.$refs[ref]
          if (chart && chart.rerender) {
            chart.rerender()
          }
        }
      }
    },
    getMaxDamage () {
      if (!this.data.results) {
        return ''
      }
      const damages = this.data.results.map(r => r.totalDamage)
      return Math.max(...damages)
    },
    getMaxDamagePercents () {
      const damage = this.getMaxDamage()
      if (!damage || damage === '') {
        return ''
      }
      return damage >= 1 ? '100 %' : (damage * 100).toFixed(1) + ' %'
    },
    getDamageValue () {
      const damage = this.getMaxDamage()
      if (!damage || damage === '') {
        return ''
      }
      return damage >= 1 ? this.$t('resourceExhausted') : damage.toFixed(3)
    },
    getResourceLeft () {
      if (!this.data.results) {
        return ''
      }
      const resources = this.data.results.map(r => r.resourceLeft)
      const minResource = Math.min(...resources)
      return minResource <= 0 ? this.$t('resourceExhausted') : minResource.toFixed(3)
    },
    getDamagePrediction () {
      if (!this.data.results) {
        return ''
      }
      const damages = this.data.results.map(r => r.totalPredictedDamage)
      const damage = Math.max(...damages)
      return damage >= 1 ? this.$t('resourceExhausted') : damage.toFixed(3)
    },
    getPredictedValue (value) {
      const damage = this.getMaxDamage()
      if (!damage || damage === '') {
        return ''
      }
      return damage >= 1 ? this.$t('resourceExhausted') : value.toFixed(2)
    },
    print () {
      window.print()
    }
  },
  mounted () {
    this.data = store.state.result
    window.scrollTo(0, 0)
    if (!this.data.results) {
      const locale = this.$route.query.lang || 'ru'
      this.$router.push({ path: '/', query: { lang: locale } })
    }
    EventBus.$on('locale-changed', () => {
      this.rerender()
    })
  }
}
</script>

<style lang="scss">
  .home {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    flex-wrap: wrap;
    align-content: stretch;

    .ta-main {
      background: #F1F6E4;
      margin: 10pt;
      max-width: 800px;
      flex-basis: 600px;
      flex-grow: 1;

      @media all and (max-width: 500px) {
        margin-left: 0;
        margin-right: 0;
      }

      .ta-row {
        padding: 5px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        vertical-align: middle;

        &:nth-of-type(even) {
          background: #E0F2D9;
        }

        &:nth-of-type(odd) {
          background: #F1F6E4;
        }

        &__inner {
          padding-left: 0;
          padding-right: 0;
        }

        .ta-input {
          width: 100%;
        }
      }

      .ta-row-block {
        padding: 5px 20px;
        background: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        vertical-align: middle;

        & + .ta-row-block {
          border-top: 1px solid;
        }
      }
    }
  }

  .ta-label {
    text-align: start;

    &__bold {
      font-weight: bold;
    }
  }

  .ta-header {
    margin-top: 10pt;
    padding-bottom: 20px;
    font-weight: bold;
    font-size: large;

    &__main {
      font-size: 25pt;
    }

    &__section {
      font-size: 18pt;
      padding: 5pt;
    }
  }

  .ta-footer {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }

  .ta-chart-header {
    display: flex;
    justify-content: center;
    font-size: 15pt;
    padding: 10pt;

    &__with-hint {
      padding-bottom: 3pt;
    }

    &__small {
      padding-top: 0;
      padding-bottom: 10pt;
      font-size: 10pt;
      font-weight: lighter;
    }
  }
</style>
